// extracted by mini-css-extract-plugin
export var chevronIcon = "_6x-2";
export var teamName = "_6x-1";
export var teamSwitcherButton = "_6x-0";